<template>
  <div class="parameter-item">
    <div class="parameter-item__actions">
      <feather-icon
        size="18"
        icon="EditIcon"
        color="green"
        v-tooltip="'Editar parámetro'"
        @click="$emit('toggle-edit', !isEditing)"
      />
      <feather-icon
        size="18"
        icon="XCircleIcon"
        color="red"
        v-tooltip="'Eliminar parámetro'"
        @click="$emit('delete')"
      />
    </div>

    <!-- View Mode -->
    <div
      v-if="!isEditing"
      class="parameter-item__view"
    >
      <div class="parameter-item__field">
        <span class="parameter-item__label">ID:</span>
        <span class="parameter-item__value parameter-item__value--mono">{{ param.parameter_id }}</span>
      </div>
      <div class="parameter-item__field">
        <span class="parameter-item__label">Nombre:</span>
        <span class="parameter-item__value">{{ param.name }}</span>
      </div>
      <div class="parameter-item__field">
        <span class="parameter-item__label">Tipo:</span>
        <span class="parameter-item__value">{{ param.type || 'text' }}</span>
      </div>
      <div
        v-if="param.description"
        class="parameter-item__field parameter-item__field--full"
      >
        <span class="parameter-item__label">Descripción:</span>
        <span class="parameter-item__value">{{ param.description }}</span>
      </div>
      <div
        v-if="param.type === 'option'"
        class="parameter-item__field parameter-item__field--full"
      >
        <ParameterOptionsList
          :options="param.options || []"
          :readonly="true"
        />
      </div>
    </div>

    <!-- Edit Mode -->
    <div
      v-if="isEditing"
      class="parameter-item__edit"
    >
      <div class="row">
        <div class="col-md-4 col-12">
          <div class="form-group">
            <label>Nombre</label>
            <input
              type="text"
              v-model="localParam.name"
              class="form-control form-control-sm"
              placeholder="Nombre del parámetro"
              @input="emitUpdate"
            >
          </div>
        </div>
        <div class="col-md-8 col-12">
          <div class="form-group">
            <label>Descripción</label>
            <input
              type="text"
              v-model="localParam.description"
              class="form-control form-control-sm"
              placeholder="Descripción del parámetro"
              @input="emitUpdate"
            >
          </div>
        </div>
        <div class="col-md-8 col-12">
          <div class="form-group">
            <label>Identificador (ID)</label>
            <input
              type="text"
              v-model="localParam.parameter_id"
              class="form-control form-control-sm"
              placeholder="Id del parámetro"
              @input="emitUpdate"
            >
          </div>
        </div>
        <div class="col-md-4 col-12">
          <div class="form-group">
            <label>Tipo</label>
            <select
              v-model="localParam.type"
              class="form-control form-control-sm"
              @change="emitUpdate"
            >
              <option value="text">Texto</option>
              <option value="number">Numero</option>
              <option value="text-large">Texto Largo</option>
              <option value="switch">Y o N</option>
              <option value="option">Opciones</option>
              <option value="s3-json">JSON en S3</option>
              <option value="s3-html">Html en S3</option>
              <option value="s3-text">Texto en S3</option>
              <option value="s3-xsl">XSL en S3</option>
              <option value="s3-file">Archivo en S3</option>
              <option value="s3-image">Imagen en S3</option>
              <option value="text-signature-template">Template Firma</option>
              <option value="set">Set de configuraciones</option>
            </select>
          </div>
        </div>
        <div
          v-if="localParam.type === 'option'"
          class="col-12"
        >
          <ParameterOptionsList
            :options="localParam.options || []"
            @update:options="onOptionsUpdate"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ParameterOptionsList from './ParameterOptionsList.vue';

export default {
  name: 'ParameterItem',
  components: {
    ParameterOptionsList
  },
  props: {
    param: {
      type: Object,
      required: true
    },
    isEditing: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localParam: this.createLocalCopy(this.param)
    };
  },
  watch: {
    param(newParam) {
      this.localParam = this.createLocalCopy(newParam);
    }
  },
  methods: {
    createLocalCopy(param) {
      return {
        ...param,
        options: param.options ? param.options.map(opt => ({ ...opt })) : []
      };
    },
    onOptionsUpdate(options) {
      this.localParam.options = options;
      this.emitUpdate();
    },
    emitUpdate() {
      this.$emit('update', { ...this.localParam });
    }
  }
};
</script>

<style scoped>
.parameter-item {
  position: relative;
  padding: 10px 40px 10px 10px;
}

.parameter-item__actions {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  gap: 8px;
}

.parameter-item__actions * {
  cursor: pointer;
}

.parameter-item__view {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px 16px;
}

.parameter-item__field {
  min-width: 0;
}

.parameter-item__field--full {
  grid-column: 1 / -1;
}

.parameter-item__label {
  font-weight: 600;
  font-size: 0.75rem;
  color: #6c757d;
  display: block;
  margin-bottom: 2px;
}

.parameter-item__value {
  display: block;
  word-break: break-all;
  font-size: 0.875rem;
}

.parameter-item__value--mono {
  font-family: monospace;
  font-size: 0.8rem;
}

.parameter-item__edit {
  padding-top: 4px;
}
</style>
